<template>
	<div>
		<div @click="handleClick" class="compentThree" :style="style1" v-if="this.realtimeData.state === true && mode === 'view'">
      <div :style="styleColumnBottom">
        <div :style="styleColumn"></div>
      </div>
      <div :style="rowBottom">
        <div :style="styleRow11"></div>
        <div :style="styleRow12"></div>
        <div :style="styleRow13"></div>
        <div :style="styleRow14"></div>
        <div :style="styleRow2"></div>
      </div>
		</div>
		
		<div class="compentThree" :style="style1" v-if="mode === 'edit'">
      <div :style="styleColumnBottom">
        <div :style="styleColumn"></div>
      </div>

			<div :style="rowBottom">
				<div :style="styleRow11"></div>
				<div :style="styleRow12"></div>
				<div :style="styleRow13"></div>
				<div :style="styleRow14"></div>
				<div :style="styleRow2"></div>
			</div>
		</div>
    <el-dialog :style="dialogStyle"
        title="子窗口页面"
        :visible.sync="modalShow"
        :width="realtimeData.modalValue+'px'"
        @close="modalShow=false"
        append-to-body>
      <div :style="modelStyle">
        <div style="width: 100%; ">
          <the-create style="width: 100%;" :companyId="companyId" :productId="realtimeData.pageId" :projectId="productSaveForm.projectId" :editType="3" :dialogCount="dialogCount+1" :readPublished="true"></the-create>
        </div>
      </div>
    </el-dialog>
	</div>

</template>

<script>
	import componentsMixin from "../componentsMixin";
	
	export default {
		name: "crossThreeComponent",
		mixins: [componentsMixin],
		data() {
			return {
				state: true,
			}
		},
    mounted() {
      console.log("style的值为",this.style)
    },
		computed: {
      dialogStyle(){
        if(this.realtimeData.modalX === undefined && this.realtimeData.modalY === undefined ){
          var applyLeft = '0'
          var applyTop = '0'
        }else if(this.realtimeData.modalX.length == 0 && this.realtimeData.modalY.length == 0){
          var applyLeft = '0'
          var applyTop = '0'
        }else if(this.realtimeData.modalX.length !== 0 && this.realtimeData.modalY.length == 0){
          var applyLeft = this.realtimeData.modalX
          var applyTop = '0'
        } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length == 0) {
          var applyLeft = '0'
          var applyTop = this.realtimeData.modalY
        } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length !== 0) {
          var applyLeft = this.realtimeData.modalX
          var applyTop = this.realtimeData.modalY
        }
        return {
          top:`calc(${applyTop}px + 10vh)`,
          left: applyLeft + 'px',
        }
      },
			style1() {
				let res = this.style;
				res['background-color'] = "rgba(0,0,0,0)"
				return res;
			},
      styleColumnBottom(){
        let res = {};
        res.position = "relative"
        if (this.settings.transform === "rotate(0deg)") {
          res.width = "20%"
          res.height = "66.67%"
          res.left = "40%"
          res.top = '0%'
          res['background'] = 'white'
        }else if (this.settings.transform === "rotate(90deg)") {
          res.width = '66.67%'
          res.height = '20%'
          res.left = '33.33%'
          res.top = '40%'
          res['background'] = 'white'
        }else if (this.settings.transform === "rotate(180deg)") {
          res.width = "20%"
          res.height = "66.67%"
          res.left = '40%'
          res.top = '33.33%'
          res['background'] = 'white'
        } else if (this.settings.transform === "rotate(270deg)") {
          res.width = '66.67%'
          res.height = '20%'
          res.top = '40%'
          res['background'] = 'white'
        }
        return res;
      },
      styleColumn() {
				let res = {};
        res.position = "relative"
				if (this.settings.transform === "rotate(0deg)") {
          res.width = "100%"
          res.height = "100%"
          res.left = "0%"
          res.top = '0%'
          res['background'] = 'linear-gradient(to right,'+ this.realtimeData.background+', rgba(255,0,0,0),'+ this.realtimeData.background +')'
        }else if (this.settings.transform === "rotate(90deg)") {
          res.width = '100%'
          res.height = '100%'
          res.left = '0%'
          res.top = '0%'
          res['background'] = 'linear-gradient(to top,'+ this.realtimeData.background+', rgba(255,0,0,0),'+ this.realtimeData.background +')';
        }else if (this.settings.transform === "rotate(180deg)") {
          res.width = "100%"
          res.height = "100%"
          res.left = '0%'
          res.top = '0%'
          res['background'] = 'linear-gradient(to right,'+ this.realtimeData.background+', rgba(255,0,0,0),'+ this.realtimeData.background +')'
        } else if (this.settings.transform === "rotate(270deg)") {
          res.width = '100%'
          res.height = '100%'
          res.top = '0%'
          res['background'] = 'linear-gradient(to top,'+ this.realtimeData.background+', rgba(255,0,0,0),'+ this.realtimeData.background +')';
        }
        return res;
			},
      rowBottom() {
        let res = {}
        res.position = "relative"
        res.background="white";
        if (this.settings.transform === "rotate(0deg)") {
          res.width = "100%"
          res.height = "33.3%"
          res.left = "0%"
          res.top = '0%'
        }else if (this.settings.transform === "rotate(90deg)") {
          res.width = "33.33%"
          res.height = "100%"
          res.left = "0%"
          res.top = '-20%'
        }if (this.settings.transform === "rotate(180deg)") {
          res.width = "100%"
          res.height = "33.33%"
          res.left = "0%"
          res.top = '-66.67%'
        }else if (this.settings.transform === "rotate(270deg)") {
          res.width = "33.33%"
          res.height = "100%"
          res.left = "66.66%"
          res.top = '-20%'
        }
        return res
      },
      styleRow11() {
				let res = {};
        res.position = "relative"
        if (this.settings.transform === "rotate(0deg)") {
          res.width = "40%"
          res.height = "50%"
          res.left = "0%"
          res.top = '0%'
          res['background'] = 'linear-gradient(to bottom,'+ this.realtimeData.background+', rgba(255,0,0,0))';
        }else if (this.settings.transform === "rotate(90deg)") {
          res.width = "50%"
          res.height = "40%"
          res.left = "50%"
          res.top = '0%'
          res['background'] = 'linear-gradient(to left,'+ this.realtimeData.background+', rgba(255,0,0,0))';
        } else if (this.settings.transform === "rotate(180deg)") {
          res.width = "40%"
          res.height = "50%"
          res.left = "60%"
          res.top = '50%'
          res['background'] = 'linear-gradient(to top,'+ this.realtimeData.background+', rgba(255,0,0,0))';
        }else if (this.settings.transform === "rotate(270deg)") {
          res.width = "50%"
          res.height = "40%"
          res.left = "0%"
          res.top = '60%'
          res['background'] = 'linear-gradient(to right,'+ this.realtimeData.background+', rgba(255,0,0,0))';
        }
				return res;
			},
      styleRow12() {
				let res = {};
        res.position = "relative"
        if (this.settings.transform === "rotate(0deg)") {
          res.width = "10%"
          res.height = "50%"
          res.left = "40%"
          res.top = "-50%"
          res['background'] = 'linear-gradient(to right bottom,'+ this.realtimeData.background+', rgba(255,0,0,0),rgba(255,0,0,0))';
        }else if (this.settings.transform === "rotate(90deg)") {
          res.width = "50%"
          res.height = "10%"
          res.left = "50%"
          res.top = "0%"
          res['background'] = 'linear-gradient(to left bottom,'+ this.realtimeData.background+', rgba(255,0,0,0),rgba(255,0,0,0))';
        } else if (this.settings.transform === "rotate(180deg)") {
          res.width = "10%"
          res.height = "50%"
          res.left = "50%"
          res.top = "0%"
          res['background'] = 'linear-gradient(to left top,'+ this.realtimeData.background+', rgba(255,0,0,0),rgba(255,0,0,0))';
        }else if (this.settings.transform === "rotate(270deg)") {
          res.width = "50%"
          res.height = "10%"
          res.left = "0%"
          res.top = "10%"
          res['background'] = 'linear-gradient(to right top,'+ this.realtimeData.background+', rgba(255,0,0,0),rgba(255,0,0,0))';
        }
				return res;
			},
      styleRow13() {
        let res = {};
        res.position = "relative"
        if (this.settings.transform === "rotate(0deg)") {
          res.width = "10%"
          res.height = "50%"
          res.left = "50%"
          res.top = "-100%"
          res['background'] = 'linear-gradient(to left bottom,'+ this.realtimeData.background+', rgba(255,0,0,0),rgba(255,0,0,0))';
        }else if (this.settings.transform === "rotate(90deg)") {
          res.width = "50%"
          res.height = "10%"
          res.left = "50%"
          res.top = "0%"
          res['background'] = 'linear-gradient(to left top,'+ this.realtimeData.background+', rgba(255,0,0,0),rgba(255,0,0,0))';
        } else if (this.settings.transform === "rotate(180deg)") {
          res.width = "10%"
          res.height = "50%"
          res.left = "40%"
          res.top = "-50%"
          res['background'] = 'linear-gradient(to right top,'+ this.realtimeData.background+', rgba(255,0,0,0),rgba(255,0,0,0))';
        }else if (this.settings.transform === "rotate(270deg)") {
          res.width = "50%"
          res.height = "10%"
          res.left = "0%"
          res.top = "-10%"
          res['background'] = 'linear-gradient(to right bottom,'+ this.realtimeData.background+', rgba(255,0,0,0),rgba(255,0,0,0))';
        }
        return res;
      },
      styleRow14() {
        let res = {};
        res.position = "relative"
        if (this.settings.transform === "rotate(0deg)") {
          res.width = "40%"
          res.height = "50%"
          res.left = "60%"
          res.top = '-150%'
          res['background'] = 'linear-gradient(to bottom,'+ this.realtimeData.background+', rgba(255,0,0,0))';
        }else if (this.settings.transform === "rotate(90deg)") {
          res.width = "50%"
          res.height = "40%"
          res.left = "50%"
          res.top = '0%'
          res['background'] = 'linear-gradient(to left,'+ this.realtimeData.background+', rgba(255,0,0,0))';
        } else if (this.settings.transform === "rotate(180deg)") {
          res.width = "40%"
          res.height = "50%"
          res.left = "0%"
          res.top = '-100%'
          res['background'] = 'linear-gradient(to top,'+ this.realtimeData.background+', rgba(255,0,0,0))';
        }else if (this.settings.transform === "rotate(270deg)") {
          res.width = "50%"
          res.height = "40%"
          res.left = "0%"
          res.top = '-60%'
          res['background'] = 'linear-gradient(to right,'+ this.realtimeData.background+', rgba(255,0,0,0))';
        }
        return res;
      },
      styleRow2() {
				let res = {};
        res.position = "relative"
        if (this.settings.transform === "rotate(0deg)") {
          res.width = "100%"
          res.height = "50%"
          res.left = "0%"
          res.top = "-150%"
          res['background'] = 'linear-gradient(to top,'+ this.realtimeData.background+', rgba(255,0,0,0))';
        }else if (this.settings.transform === "rotate(90deg)") {
          res.width = "50%"
          res.height = "100%"
          res.left = "0%"
          res.top = "-100%"
          res['background'] = 'linear-gradient(to right,'+ this.realtimeData.background+', rgba(255,0,0,0))';
        } else if (this.settings.transform === "rotate(180deg)") {
          res.width = "100%"
          res.height = "50%"
          res.left = "0%"
          res.top = "-200%"
          res['background'] = 'linear-gradient(to bottom,'+ this.realtimeData.background+', rgba(255,0,0,0))';
        }else if (this.settings.transform === "rotate(270deg)") {
          res.width = "50%"
          res.height = "100%"
          res.left = "50%"
          res.top = "-100%"
          res['background'] = 'linear-gradient(to left,'+ this.realtimeData.background+', rgba(255,0,0,0))';
        }
				return res;
			},
		},
		watch: {
      // 根据realtimeData中的值,更新wrapperStyle的值
      // 'realtimeData.top': {  // x绑定
      //   handler() {
      //     this.wrapperStyle.top = this.realtimeData.top +'px'
      //   }
      // },
      // 'realtimeData.left': {  // y绑定
      //   handler() {
      //     this.wrapperStyle.left = this.realtimeData.left +'px'
      //   }
      // },
      // 'realtimeData.height': {  // 高度绑定
      //   handler() {
      //     this._style.height = this.realtimeData.height + 'px'  // componentsMixin 中对 _style 进行了检查更新style 绑定至矩形框
      //     this.wrapperStyle.height = this.realtimeData.height +'px'
      //   }
      // },
      // 'realtimeData.width': {  // 宽度绑定
      //   handler() {
      //     console.log("宽度发生改变",this.realtimeData.width,this.style)
      //     this._style.width = this.realtimeData.width + 'px'
      //     this.wrapperStyle.width = this.realtimeData.width +'px'  // 编辑框
      //   }
      // },
			
		}
	}
</script>

<style scoped>
	.compentThree {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;

  }
  ::v-deep .el-dialog{
    margin:0 !important;
    position:absolute;
  }
</style>